module.exports = __webpack_public_path__ + "img/Customer.23d9f2b5.svg";